import { useState } from "react";
import { Ban } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { useRegisterMutations } from "@/features/power_projects/hooks";
import type { CorrespondenceRegister } from "@/features/power_projects/types";

// ── wycofanie pisma z kolejki wysyłki (autor, przed wysłaniem) ─────────────────
// Dopóki dział obiegu pisma nie wysłał, autor może je z kolejki zdjąć — bez chodzenia do
// działu obiegu i bez zakładania „poprawionego" dubla obok pierwszego. Wpis zostaje w
// dzienniku jako „Anulowane" (z historią i powodem), znika tylko z kolejki „Do wysłania".
export function CancelDispatchButton({ row }: { row: CorrespondenceRegister }) {
  const m = useRegisterMutations();
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  if (!open) {
    return (
      <Button
        size="sm"
        variant="ghost"
        title="Wycofaj pismo z kolejki wysyłki — dział obiegu go nie wyśle. Wpis zostaje w dzienniku jako „Anulowane”."
        onClick={() => setOpen(true)}
      >
        <Ban size={13} />
        Anuluj wysyłkę
      </Button>
    );
  }
  return (
    <div className="w-[220px] border border-[var(--color-border)] border-l-[3px] border-l-[var(--color-primary)] bg-[var(--color-bg-surface)] p-2 space-y-2">
      <div className="text-[11px] text-[var(--color-text-secondary)]">
        Pismo nie zostanie wysłane. Wpis zostaje w dzienniku jako „Anulowane”.
      </div>
      <label className="block space-y-1">
        <span className="section-label">Powód (opcjonalnie)</span>
        <input
          className="input-base text-xs py-1.5"
          placeholder="np. zły załącznik"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </label>
      <div className="flex gap-1.5">
        <Button
          size="sm"
          variant="danger"
          loading={m.cancelOutgoing.isPending}
          onClick={() => m.cancelOutgoing.mutate({ id: row.id, note }, { onSuccess: () => setOpen(false) })}
        >
          <Ban size={13} />
          Wycofaj
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setOpen(false)}>Nie</Button>
      </div>
      {m.cancelOutgoing.isError && (
        <span className="block text-[11px] text-red-600">
          {(m.cancelOutgoing.error as { response?: { data?: { errors?: { detail?: string } } } })
            ?.response?.data?.errors?.detail ?? "Nie udało się wycofać pisma."}
        </span>
      )}
    </div>
  );
}
